export default __webpack_public_path__ + "static/media/gerenciamento-contas.40116e8a.png";